module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACCSURBVCiRvZFhDYAgFIRPkhjBSibRBkawgg2MYAQiSIPPP/zAJ2wMNm9jg+O+wd5JiQAPeBmV/DQAQI3vgMVeYJTxlyH3Qo1cC9Sl/79aAwZJs6Tj5drRA1eyv4Ep5s5XRQbaYmg30P7p1pzT8FiCcqCFsxBAqY4Q11iaWFePawO3Pi5+G8Q9TyYEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Path.png
// module id = CSsj
// module chunks = 1